export enum IndeedIndustry {
    'UNASSIGNED' = 'Unassigned',
    'ACCOUNTING_CONSULTING' = 'Accounting Consulting',
    'ADVERTISING_MARKETING' = 'Advertising Marketing',
    'AGRICULTURE' = 'Agriculture',
    'ARTS_ENTERTAINMENT_RECREATION' = 'Arts Entertainment Recreation',
    'AUTOMOTIVE' = 'Automotive',
    'BEAUTY_WELLNESS' = 'Beauty Wellness',
    'CONSTRUCTION_ENGINEERING' = 'Construction Engineering',
    'DEFENSE_SECURITY' = 'Defense Security',
    'EDUCATION' = 'Education',
    'ENERGY_UTILITIES' = 'Energy Utilities',
    'FINANCIAL_SERVICES_BANKING' = 'Financial Services Banking',
    'FOOD_BEVERAGE_SERVICES' = 'Food Beverage Services',
    'FRAUD_SCAM' = 'Fraud Scam',
    'GOVERNMENT_MILITARY' = 'Government Military',
    'HEALTH_CARE_MEDICAL' = 'Health Care Medical',
    'HOSPITALITY' = 'Hospitality',
    'INSURANCE' = 'Insurance',
    'JOB_BOARD_GENERAL' = 'Job Board General',
    'JOB_SEEKER' = 'Job Seeker',
    'LEGAL' = 'Legal',
    'MANUFACTURING' = 'Manufacturing',
    'MEDIA_NEWSPAPER' = 'Media Newspaper',
    'NON_PROFIT_ASSOCIATION' = 'Non Profit Association',
    'OTHER' = 'Other',
    'REAL_ESTATE' = 'Real Estate',
    'RETAIL_CONSUMER_PRODUCTS' = 'Retail Consumer Products',
    'SPAM' = 'Spam',
    'STAFFING_FIRM_GENERAL' = 'Staffing Firm General',
    'TECHNOLOGY_INFORMATION' = 'Technology Information',
    'TELECOM' = 'Telecom',
    'TRANSPORTATION_LOGISTICS' = 'Transportation Logistics',
    'WORK_AT_HOME' = 'Work At Home',
    'XO_S_JS' = 'Xo S Js',
}
